import { API_URL } from "../config/api";

const TOKEN_KEY = "neko_auth_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

// Wrapper around fetch that automatically adds the user token and parses JSON.
// Throws an Error with .status and the message returned by the backend on failure.
export async function apiFetch(path, { method = "GET", body, auth = true } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth) {
    const token = getToken();
    if (token) headers["x-auth-token"] = token;
  }

  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (!res.ok) {
    const err = new Error((data && data.error) || `Error ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

// Fire-and-forget: records that the logged-in user opened a given page, for
// the "explorer" achievements. No-ops silently when logged out or offline —
// never let this affect the page itself.
export function trackVisit(page) {
  if (!getToken()) return;
  apiFetch("/api/users/me/track-visit", { method: "POST", body: { page } }).catch(() => {});
}
